import { CONST_ROWS_PER_PAGE } from '@commons/consts';
import {
    NEW_CONTROLE_PRAGA_DOENCA_SUCCESS,
    TABLE_CONTROLE_PRAGA_DOENCA_PENDING,
    TABLE_CONTROLE_PRAGA_DOENCA_SUCCESS,
    TABLE_CONTROLE_PRAGA_DOENCA_FAILURE,
    LIST_CONTROLE_PRAGA_DOENCA_PENDING,
    LIST_CONTROLE_PRAGA_DOENCA_SUCCESS,
    LIST_CONTROLE_PRAGA_DOENCA_FAILURE,
    FIND_CONTROLE_PRAGA_DOENCA_PENDING,
    FIND_CONTROLE_PRAGA_DOENCA_SUCCESS,
    FIND_CONTROLE_PRAGA_DOENCA_FAILURE,
    DELETE_CONTROLE_PRAGA_DOENCA_PENDING,
    DELETE_CONTROLE_PRAGA_DOENCA_SUCCESS,
    DELETE_CONTROLE_PRAGA_DOENCA_FAILURE,
    CREATE_CONTROLE_PRAGA_DOENCA_PENDING,
    CREATE_CONTROLE_PRAGA_DOENCA_SUCCESS,
    CREATE_CONTROLE_PRAGA_DOENCA_FAILURE,
    NEW_FILTER_CONTROLE_PRAGA_DOENCA_PENDING,
    NEW_FILTER_CONTROLE_PRAGA_DOENCA_SUCCESS,
    NEW_FILTER_CONTROLE_PRAGA_DOENCA_FAILURE,
    NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_PENDING,
    NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_SUCCESS,
    NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_FAILURE,
    MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_PENDING,
    MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_SUCCESS,
    MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_FAILURE,
    MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_PENDING,
    MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_SUCCESS,
    MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_FAILURE,
} from './actionTypes';


const initialState = {
    list: null,
    loading: false,
    filter: { rows: CONST_ROWS_PER_PAGE, page: 0, where: '' }
}


function controlePragaDoencaReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_CONTROLE_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro,
            }
        case LIST_CONTROLE_PRAGA_DOENCA_PENDING:
        case FIND_CONTROLE_PRAGA_DOENCA_PENDING:
        case DELETE_CONTROLE_PRAGA_DOENCA_PENDING:
        case CREATE_CONTROLE_PRAGA_DOENCA_PENDING:
        case TABLE_CONTROLE_PRAGA_DOENCA_PENDING:
        case NEW_FILTER_CONTROLE_PRAGA_DOENCA_PENDING:
        case NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_PENDING:
        case MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_PENDING:
        case MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_CONTROLE_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_CONTROLE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_CONTROLE_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_CONTROLE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_CONTROLE_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_CONTROLE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_CONTROLE_PRAGA_DOENCA_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_CONTROLE_PRAGA_DOENCA_SUCCESS:
        case CREATE_CONTROLE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro,
            }
        case DELETE_CONTROLE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_CONTROLE_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_CONTROLE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_CONTROLE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_SUCCESS:
        case MARCAR_TRATADO_CONTROLE_PRAGA_DOENCA_FAILURE:
        case MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_SUCCESS:
        case MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_FAILURE:
            return {
                ...state,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { controlePragaDoencaReducer };
